
import Sku from "@core/Sku.js";
import {$array, $event_publisher, $util,$cookie} from "@util/util.js";
import Constant from "@constant/index.js";
import AdditionalFactory from "../../factory/Additional.js";
import PromotionFactory from "../../factory/Promotion.js";
import ViewFactory from "@factory/View.js";
import ActionTool from "@core/ActionTool.js";
import API from "@api/index.js";

export default class MainSku extends Sku{
    constructor(){
        super();
        this._type = Constant.MODEL_TYPES.MAINSKU;
        //数据冗余
        this._originData = null;

        this._data = null;

        this._parent = null;

        this._totalPrice = null;

        //库存和限购提示的文案
        this._purchaseMsg = "";

        //找相似商品数据源
        this._similarityGoods = [];
        // 选件
        this.giftsSelectGoods = [];
        //私人定制
        this._cto = null;
        //赠品
        this._gift = null;
        //服务
        this._service = null;
        //选件
        this._option = null;
        //coupon
        this._coupon = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.COUPON, []);
        this._coupons = []
        //package
        this._package = null;

        //预售
        this._booking = null;
        //秒杀
        this._kill = null;
        //下单立减
        this._orderReduce = null;
        //预约
        this._subscribe = null;
        //预约抢购
        this._subscribeSnap = null;
        // 是否有优惠券
        this._hasCoupons = false;
        // 是否有服务
        this._hasServices = false;
        // 是否有选件
        this._hasOptions = false;
        //服务商品列表
        this._serviceGoods = null;
        // 私人订制
        this._prsonalTalorList = null;
        // 选件组件
        this._optionList = null;
        // 赠品组件
        this._giftList = null;
         // 私人定制列表组件
         this._personalGoods = null;
        // 到货通知组件
        this._arrivalGoods = null;
        // wap编辑状态是否选中
        this._isChecked_fake = false;    
        // 是否小时达
        this._isHours = false;
        // 预估到手价
        this._deliveryPrice = null;
    }

    setParent(parent){
        this._parent = parent;
    }

    //获取主品失效状态对应的文案
    getInvalidMsg() {
        if (this._invalid) {
            if(this._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
                return Constant.MSG.NOSTOCK;
            }
            if(this._marketable == false){
                return Constant.MSG.NO_MARKETABLE;
            }else if(this._stock <= 0){
                return Constant.MSG.NOSTOCK; 
            }else{
                // return Constant.MSG.INVALID;
                return ''
            }
        } else {
            return "";
        }
    }

    readyToReadyPromotion(){
        let promotionViews = [];
        this._orderReduce && promotionViews.push(new ViewFactory().create(Constant.MODEL_TYPES.ORDER_REDUCE, this._orderReduce));
        this._booking && promotionViews.push(new ViewFactory().create(Constant.MODEL_TYPES.BOOKING, this._booking));
        if(this._kill ){
            if(this._kill._type == Constant.MODEL_TYPES.KILL){
               promotionViews.push(new ViewFactory().create(Constant.MODEL_TYPES.KILL, this._kill));
            }else{
                promotionViews.push(new ViewFactory().create(Constant.MODEL_TYPES.KILL_COUNTDOWN, this._kill));
            }
        }        
        this._subscribe && promotionViews.push(new ViewFactory().create(Constant.MODEL_TYPES.SUBSCRIBE, this._subscribe));
        this._subscribeSnap && promotionViews.push(new ViewFactory().create(Constant.MODEL_TYPES.SUBSCRIBESNAP, this._subscribeSnap));
        
        //已失效/已售罄商品部渲染促销信息
        promotionViews.forEach(x=>{
            if(!this._invalid){
                x.render();
            }
        })
    }

    readyToReadyAdditional(){
        let additionalViews = [];

        this._service && additionalViews.push(new ViewFactory().create(Constant.MODEL_TYPES.SERVICE, this._service));        
        this._gift && additionalViews.push(new ViewFactory().create(Constant.MODEL_TYPES.GIFT, this._gift));
        this._cto && additionalViews.push(new ViewFactory().create(Constant.MODEL_TYPES.CTO, this._cto));
        this._option && additionalViews.push(new ViewFactory().create(Constant.MODEL_TYPES.OPTION, this._option));
        this._package && additionalViews.push(new ViewFactory().create(Constant.MODEL_TYPES.PACKAGE, this._package));
        
        this._view.clearExtraBox();
        additionalViews.forEach(x=>{
            x.render();
        })
    }

    //data：mainSku的主数据, originData：group主数据
    init(data, originData){
        this._data = data;
        this._originData = originData?originData:this._originData;
        this._name = data.name;
        this._price =  (isNaN(data.price.showAmount)?data.price.showAmount:data.price.showAmount);
        this._addPrice = data.priceComparisonDesc?data.priceComparisonDesc:"";
        this._count = data.num;
        // 是否绑定服务商品
        this._hasServices = data.containsService ? data.containsService : false;
        // 是否有选件
        this._hasOptions = data.attributes && data.attributes.isOptions  && data.attributes.isOptions == 1 ? true : false;
        //如果是满减, 取当前主品的check属性
        if(this._parent._itemType != Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            this._isChecked = this._originData.check == 0?false:true;           
        }else{
            // this._isChecked = data.check == 0?false:true;
            this._isChecked = this._originData.check == 0?false:true;
        }
        
        this._img = data.imgUrl;
        this._link = data.url;
        this._id = data.id;
        //满减的itemId在单行里面，其他的挂在group里面
        if(this._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            this._itemId = data.itemId || originData.itemId;
            this._parent._itemId = "";
            this._invalid = data.invalid;
            this._purchaseEnable = data.purchaseEnable;      
            if(originData.attributes && originData.attributes.isHours && originData.attributes.isHours == "1"){
                this._isHours = true;
            }            
        }else{
            this._itemId = this._parent._itemId;
            this._invalid = this._parent._invalid;
            this._purchaseEnable = originData.purchaseEnable;
            if(data.attributes && data.attributes.isHours && data.attributes.isHours == "1"){
                this._isHours = true;
            }            
        }
        // 处理wap编辑状态是否选中
        if(_engine._editStatus && _engine._editSelectedDisablePurchaseGoods){
            // wap编辑状态下记录选中的不可购买商品 包含当前商品设置 假选中状态为true
            if(_engine._editSelectedDisablePurchaseGoods.includes(this._itemId)){
                this._isChecked_fake = true;
            }
        } 
        this._disabled = data.invalid;
        // 如果存在到手价则使用xiaojiNew，否则使用xiaoji
        this._totalPrice =  (data.deliveryPrice ? data?.xiaojiNew?.showAmount : data?.xiaoji?.showAmount) || ''
        this._stock = data.stock;           //0:已售罄
        this._maxPurchase = data.maxPurchase;
        this._marketable = data.marketable; //false:已下架
        this._deliveryPrice = data.deliveryPrice;
        

        this.setAdditional();
        this.setPromotion();

        this.getStockMsg();
    }

    // 获取优惠券列表
    getCouponList(){
        let _params = {
            shopId: window._shopId,
            // getTerminal: window._terminal,
            terminal: window._terminal,
            cartItemId: this._itemId
        };
        return new Promise((reslove,reject)=>{
            API.getCouponList(_params).then(x=>{           
                this._coupon = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.COUPON, x.t) 
                this._coupon.setParent(this);   
                new ViewFactory().create(Constant.MODEL_TYPES.COUPON, this._coupon);
                reslove()             
            }).catch(err=>{
                reject(`获取优惠券列表出错:${JSON.stringify(_params)}`)
            })
        })
    }
    // 获取到货通知数据
    getArrival(data) {
        return new Promise((reslove,reject)=>{       
            this._arrivalGoods = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.ARRIVALGOODS, data) 
            
            this._arrivalGoods.setParent(this);   
            new ViewFactory().create(Constant.MODEL_TYPES.ARRIVALGOODS, this._arrivalGoods);
            reslove()
        })
    }
    // 获取服务商品列表
    getServiceList(data){
        let _params = {            
            code: this._id
        };
        return new Promise((reslove,reject)=>{
            API.getServiceList(_params).then(x=>{  

                this._serviceGoods = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.SERVICELIST, x.t);

                this._serviceGoods.setParent(this);   
                new ViewFactory().create(Constant.MODEL_TYPES.SERVICELIST, this._serviceGoods);
                
                reslove()   
            }).catch(err=>{
                reject(`获取服务商品列表出错:${JSON.stringify(_params)}`)
            })
        })
    }
    setPromotion(){
        let _activity = this._data.activity;
        if(_activity){
            //秒杀
            if(_activity.type == Constant.PROMOTION_TYPE.KILL.TYPE || _activity.type == Constant.PROMOTION_TYPE.KILL_COUNTDOWN.TYPE ){
                this._kill = new PromotionFactory().create(_activity.type, _activity);
                this._kill.setParent(this);
            }
            //预约
            if(_activity.type == Constant.PROMOTION_TYPE.SUBSCRIBE.TYPE){
                this._subscribe = new PromotionFactory().create(_activity.type, _activity);
                this._subscribe.setParent(this);
            }
            //预约抢购
            if(_activity.type == Constant.PROMOTION_TYPE.SUBSCRIBE_SNAP.TYPE){
                this._subscribeSnap = new PromotionFactory().create(_activity.type, _activity);
                this._subscribeSnap.setParent(this);
            }
        }
        //下单立减
        let _promotions = this._data.promotions;
        if(_promotions && $array.isArray(_promotions) && _promotions.length != 0){
            this._orderReduce = new PromotionFactory().create(Constant.PROMOTION_TYPE.ORDER_REDUCE.TYPE, _promotions[0]);
            this._orderReduce.setParent(this);
        }
        //预售
        // 2022.10.17 需求新增候补销售，即预售分两种： a. 普通预售: 0 b. 候补销售: 1
        if(this._data.salesType == Constant.SALES_TYPE.BOOKING.TYPE){
            // 候补销售
            if (this._data.presellType == 1) {
                this._booking = new PromotionFactory().create(Constant.PROMOTION_TYPE.BOOKING.TYPE, this._data);
                this._booking.setParent(this);
            } else { // 普通预售
                this._booking = new PromotionFactory().create(Constant.PROMOTION_TYPE.BOOKING.TYPE, this._data);
                this._booking.setParent(this);   
            }
        }
    }

    setAdditional(){
        //私人订制
        let _ctoData = this._data.attributes;
        if(_ctoData && !$array.isNullArray(_ctoData.personalization_list)){
            this._cto = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.CTO, _ctoData.personalization_list);
            this._cto.setParent(this);
        }else{
            this._cto = null;
        }
        //赠品
        let _giftData = this._data.gifts;
        if(_giftData && !$array.isNullArray(_giftData)){
            this._gift = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.GIFT, _giftData);
            this._gift.setParent(this);
        }else{
            this._gift = null;
        }
        //服务
        let _serviceData = this._data.services;
        if(_serviceData && !$array.isNullArray(_serviceData)){
            this._service = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.SERVICE, _serviceData);
            this._service.setParent(this);
        }else{
            this._service = null;
        }
        //选件
        if(this._parent._itemType == Constant.GROUP_TYPE.OPTION.TYPE || this._originData.type == Constant.GROUP_TYPE.OPTION.TYPE){
            let _optionData = this._originData.skus.slice(1);
            if(_optionData && !$array.isNullArray(_optionData)){
                this._option = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.OPTION, _optionData);
                this._option.setParent(this);
            }
        }else{
            this._option = null;
        }
        //套餐
        if(this._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            let _packageData = this._originData.skus.slice(1);
            if(_packageData && !$array.isNullArray(_packageData)){
                this._package = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.PACKAGE, _packageData);
                this._package.setParent(this);
            }
        }
    }

    //激活状态
    setActive(){
        if(this._active_status == false){
            return Promise.reject(Constant.MSG.ACTIVEING);
        }
        this._active_status = false;
        return new Promise((resolve, reject)=>{
            ActionTool.setActive({model:this}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //重新设置MainSku的属性 + 重新渲染附属商品
                $event_publisher.broadcast(Constant.EVENT_KEY.CHANGE_MAINSKU_ACTIVE, {model:this, data:data});
                $event_publisher.broadcast(Constant.EVENT_KEY.RERENDER_CART,data);
                resolve();
                this._active_status = true;
            }).catch(err=>{
                reject(err);
                this._active_status = true;
            })
        })
    }

    //wap编辑状态下选中
    setFakeActive(){ 
        if(this._isChecked_fake){
            this._isChecked_fake = false;
            if(_engine._editSelectedDisablePurchaseGoods){
                // wap编辑状态下记录选中的不可购买商品 去除
                _engine._editSelectedDisablePurchaseGoods.pop(this._itemId);
                _engine._editSelectedDisablePurchaseGoodsNum -= this._count;
            } 
        }else{
            this._isChecked_fake = true;
            if(_engine._editSelectedDisablePurchaseGoods){
                // wap编辑状态下记录选中的不可购买商品 添加
                _engine._editSelectedDisablePurchaseGoods.push(this._itemId);
                _engine._editSelectedDisablePurchaseGoodsNum += this._count;
            }
        }    
        //更新price组件的全选状态  
        //编辑状态判断是否全选，接口返回的选中的总数+不可购买商品的选中总数 == 购物车总数-失效商品数
        if(_engine._price._totalCheckedCount != 0  && (_engine._price._totalCheckedCount + _engine._editSelectedDisablePurchaseGoodsNum == _engine._price._totalCount - _engine._price._invalidNum) ){
            _engine._price._isChecked = true;
        }else{
            _engine._price._isChecked = false;
        } 
    }

    //更改数量
    modifyCount(count){
        if(this._modify_count_status == false){
            return Promise.reject(Constant.MSG.MODIFYING);
        }
        this._modify_count_status = false;
        return new Promise((reslove,reject)=>{
            ActionTool.modifyCount({model:this, count:count}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //重新设置MainSku的属性 + 重新渲染附属商品
                $event_publisher.broadcast(Constant.EVENT_KEY.MODIFY_MAINSKU_COUNT, {model:this, data:data});
                reslove();
                this._modify_count_status = true;
            }).catch(err=>{
                reject(err);
                this._modify_count_status = true;
            })
        })
    }

    //删除主品
    removeMainSku(){
        return new Promise((reslove,reject)=>{
            ActionTool.removeAction({model:this}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //通知Group，里面有MainSku被删除
                $event_publisher.broadcast(Constant.EVENT_KEY.REMOVE_MAINSKU, this);
                reslove();
            }).catch(err=>{
                reject(err);
            })
        });
    }

    //移入收藏夹
    addToFavorite(){
        return new Promise((reslove,reject)=>{
            ActionTool.addFavorite(this._id).then(data=>{
                this.removeMainSku().then(()=>{
                    reslove();
                }).catch(err=>{
                    reject(err);
                });
            }).catch(err=>{
                reject(err);
            })
        });
    }

    //库存和限购提示的文案
    getStockMsg(){       
        //商品失效不提示， 不可购买的时候需要提示 这个不知道哪个提过这个需求，需求无效以SHOP-30064为准
        //SHOP-30064 5.当有效商品不可勾选购买时不显示限购和库存的提示信息
        if(this._invalid || this._purchaseEnable == false){
        // if(this._invalid ){
            this._purchaseMsg = "";
            return;
        }
        // SHOP-30064
        if(this._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE){
            if(this._stock < this._count ){
                this._purchaseMsg = Constant.MSG.STOCK_NOT_ENOUGH;                
            }else if(this._stock <= 3 ){
                this._purchaseMsg = Constant.MSG.STOCK;                
            }else if(this._maxPurchase <= 5 /*|| this._count == this._maxPurchase*/){
                // 是活动商品
                if($util.getMainSkuHasPromotion(this)){
                    this._purchaseMsg = "限购"+this._maxPurchase+"件";
                }else if (this._count >= this._maxPurchase){
                    this._purchaseMsg = "限购"+this._maxPurchase+"件";
                }
                else{
                    this._purchaseMsg = ""; 
                }                               
            }else{
                this._purchaseMsg = "";                
            }
            return;
            
        }
    }

    getSimilarityGoods(){
        return new Promise((resolve, reject)=>{
            // if(this._similarityGoods.length != 0){
            //     resolve();
            // }else{
                /*let params ={
                    shopid: window._shopId,
                    terminal: window._terminal,
                    source: window._terminal == "1" ? "S0001001" : "S0001003",
                    scenario: "cart_offline_recm",
                    uidType: "IT0000009",
                    product: this._id
                };*/
                let params ={                    
                    terminal: window._terminal,
                    source: window._terminal == "1" ? "S0001001" : "S0001003",
                    scenario: "ocart",
                    uid: passport && passport.cookie && passport.cookie.lenovoId, // lenovoId
                    uidType: "IT0000001",
                    uid2: this._id, // goodsId
                    uidType2: 'IT0000009',
                    time: (new Date()) - 0,
                };
                API.getSimilarityGoods(params).then(x=>{
                    // this._similarityGoods = x.t.goodsDetails;
                    this._similarityGoods = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.SIMILARITYGOODS,x.t) 
                    this._similarityGoods.setParent(this);   
                    new ViewFactory().create(Constant.MODEL_TYPES.SIMILARITYGOODS, this._similarityGoods);
                    resolve()
                }).catch(err=>{
                    reject(err)
                })
            // }
        })
    }

    //更改购物车行项目的附属
    modifyItemFromCart(params){        
        return new Promise((reslove,reject)=>{
            ActionTool.modifyItemFromCart({model:this, opsType:params.opsType,content:params.content}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                // //重新设置MainSku的属性 + 重新渲染附属商品
                // $event_publisher.broadcast(Constant.EVENT_KEY.MODIFY_MAINSKU_COUNT, {model:this, data:data});
                //重新渲染购物车
                $event_publisher.broadcast(Constant.EVENT_KEY.RERENDER_CART, data); 
                reslove();               
            }).catch(err=>{
                reject(err);
            })
        })
    }

    // 获取主品关联的选件
    getOptionGoods(){
        return new Promise((resolve, reject)=>{   
            let _lenovoId = "";
            if(passport && passport.cookie && passport.cookie.lenovoId){
                _lenovoId = passport.cookie.lenovoId;
            } else if($cookie.getCookie("leid")){
                _lenovoId = $cookie.getCookie("leid");
            }         
            let params ={
                salesPlat: window._terminal,                  
                code: this._id,
                displayArea:'shoppingcart',
                lenovoId:_lenovoId         
            };
            API.getOptionsAndGifts(params).then(x=>{
                if(x.t && x.t.option && x.t.goodsDetailUrl){
                    //处理商品状态和商品详情url
                    for(var i = 0; i < x.t.option.length; i++){                       
                        if(x.t.option[i].code in x.t.limitedNumber){
                            x.t.option[i].limitedNumber  = x.t.limitedNumber[x.t.option[i].code];
                        }                          
                        if(x.t.option[i].code in x.t.goodsDetailUrl){
                            x.t.option[i].goodsDetailUrl  = x.t.goodsDetailUrl[x.t.option[i].code];
                        }                       
                    }

                    this._optionList = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.OPTIONLIST,x.t.option) 
                    this._optionList.setParent(this);   
                    new ViewFactory().create(Constant.MODEL_TYPES.OPTIONLIST, this._optionList);
                    resolve();
                }else{
                    reject({msg:"获取商品关联的选件出错"})
                }
               
            }).catch(err=>{

                reject(err)
            })            
        })
    }
    // 获取主品关联的可选赠品
    getGiftGoods(){
        return new Promise((resolve, reject)=>{    
            let _lenovoId = "";
            if(passport && passport.cookie && passport.cookie.lenovoId){
                _lenovoId = passport.cookie.lenovoId;
            } else if($cookie.getCookie("leid")){
                _lenovoId = $cookie.getCookie("leid");
            }
            let params ={
                salesPlat: window._terminal,                  
                code: this._id,
                lenovoId:_lenovoId                 
            };
            API.getOptionsAndGifts(params).then(x=>{
                if(x.t && x.t.giftsSelectable && x.t.goodsDetailUrl){
                    //处理商品状态和商品详情url
                    for(let i = 0; i < x.t.giftsSelectable.length; i++){                               
                        if(x.t.giftsSelectable[i].code in x.t.goodsDetailUrl){
                            x.t.giftsSelectable[i].goodsDetailUrl  = x.t.goodsDetailUrl[x.t.giftsSelectable[i].code];
                        }                        
                    }
                    this._giftList = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.GIFTLIST,x.t) 
                    this._giftList.setParent(this);   
                    new ViewFactory().create(Constant.MODEL_TYPES.GIFTLIST, this._giftList);
                    resolve();
                }else{
                    reject({msg:"获取商品关联的可选赠品出错"})
                }
            }).catch(err=>{
                reject(err)
            })            
        })
    }
    //商品加入购物车
    addGoodsToCard(_params){
        return new Promise((resolve, reject)=>{            
            let params ={
                shopId: window._shopId,
                terminal:window._terminal,
                itemtype:_params.itemtype,
                gcodes: _params.gcodes,
                icount: _params.icount 
            };
            API.addGoodsToCard(params).then(x=>{
                // //价格变动
                // $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                // //重新渲染购物车
                // $event_publisher.broadcast(Constant.EVENT_KEY.RERENDER_CART, data); 
                resolve(x);
            }).catch(err=>{
                reject(err)
            })            
        })

    }
    // 获取私人定制数据源
    getPersonalGoods(e){
        
        return new Promise((resolve, reject)=>{        
            if(this._personalGoods ){
                resolve();
            }else{
                let params ={                              
                    code: e.code                
                };
                API.getPersonalGoods(params).then(x=>{
                    this._personalGoods = new AdditionalFactory().create(Constant.ADDITIONAL_TYPE.PERSONALGOODS,x.t);
                    this._personalGoods.setParent(this);
                    if(this._personalGoods._aSideData.length > 0){
                        this.getPersonalPictures({code : this._personalGoods._aSideData[0].code}).then(t=>{       
                            this._personalGoods.setPictures(t);
                            new ViewFactory().create(Constant.MODEL_TYPES.PERSONALGOODS, this._personalGoods);
                            resolve();
                        }).catch(err=>{
                            new ViewFactory().create(Constant.MODEL_TYPES.PERSONALGOODS, this._personalGoods);
                            resolve();
                            //reject(err)
                        }) 
                    }else{
                        // new ViewFactory().create(Constant.MODEL_TYPES.GIFTLIST, this._giftList);
                        new ViewFactory().create(Constant.MODEL_TYPES.PERSONALGOODS, this._personalGoods);
                        resolve();
                    }
                    
                }).catch(err=>{
                  console.log(645);
                    reject(err)
                })  
            }          
        })
    }

    // 获取私人定制商品图片信息
    getPersonalPictures(params){
        return new Promise((resolve, reject)=>{
            let _params ={                              
                code: params.code                    
            };
            API.getPersonalPictures(_params).then(x=>{  
                this._personalGoods.setPictures(x&&x.t.data || []);
                // $event_publisher.broadcast(Constant.ADDITIONAL_TYPE.PERSONALGOODS, {model:this, _personalGoods:x&&x.t.data || []});
                resolve(x&&x.t.data || []);
            }).catch(err=>{
                reject(err)
            }) 
        })
    }
    getPersonalPicturess(params){
        return new Promise((resolve, reject)=>{
            let _params ={                              
                code: params.code                    
            };
            API.getPersonalPictures(_params).then(x=>{  
                this._personalGoods.setPictures(x&&x.t.data || []);
                new ViewFactory().create(Constant.MODEL_TYPES.PERSONALGOODS, this._personalGoods);
                // $event_publisher.broadcast(Constant.ADDITIONAL_TYPE.PERSONALGOODS, {model:this, _personalGoods:x&&x.t.data || []});
                resolve(x&&x.t.data || []);
            }).catch(err=>{
                reject(err)
            }) 
        })
    }
}